import React, { Component } from 'react'

import FlipMove from 'react-flip-move'

import SectionControls from 'components/controls/section-controls'
import DateContainer from 'components/date-container/date-container'

import {
	saveItem,
	openModal,
} from 'state/actions'

import { getCurrentUser } from 'state/selectors/userSelectors'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import moment from 'moment'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import copy from 'fast-copy'

import Note from './project-note'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import {
	paragraphToLines,
	getMentionableUsers,
	getMentionIdsFromComment,
	isMobile,
	doClickEventListeners,
	getAvailableNotes,
} from 'utils'

import MobileFooterButtons from 'components/mobile/footer-buttons'

import isEqual from 'react-fast-compare'
import QuillWysiwyg from 'components/input/quill-wysiwyg'
import InputStandard from 'components/input/standard'
import TagsInput from 'components/input/tags'

import { API_URL } from 'state/api'

import SmoothCollapse from 'react-smooth-collapse'

import { MainContext } from 'context'

class ProjectNotes extends Component {
	constructor(props) {
		super(props)

		this.emptyNoteTemplate = {
			id: false,
			text: '',
			name: '',
			project_id: this.props.currentProjectId,
			mentionIds: [],
			start_date: null,
			location: '',
			visible_to_guests: true
		}

		this.state = {
			isEditorVisible: false,
			currentNote: {
				...this.emptyNoteTemplate
			},
			userMentions: getMentionableUsers(this.props.applicableUsers),
			showingMeetingFields: false,
			datePickerOpen: false,
			isExportLoading: false,
		}

		this.projectNotes = []

		this.saveDebounce
	}

	handleChange = value => {
		this.saveNote('text', value)
	}

	handleTextChange = (value, type) => {
		this.saveNote(type, value)
	}

	saveNote = (field, value, _, force = false) => {
		const {
			isArchivedProject
		} = this.props

		if(isArchivedProject){
			return 
		}

		const currentNote = copy(this.state.currentNote)

		let debounceLength = 1000
		clearTimeout(this.saveDebounce)

		if (field == 'text') {
			if(!isMobile()){
				currentNote.mentionIds = getMentionIdsFromComment(value)
			}

			if(value){
				value = value.replace(/style="[a-zA-Z0-9:;\.\s\(\)\-\,]*"/gi, '')
			}else{
				value = ''
			}
		}

		if (!force) {
			currentNote[field] = value

			this.setState({
				currentNote
			})
		} else {
			debounceLength = 0
		}

		this.saveDebounce = setTimeout(_ => {
			currentNote.attendants = this.getStringsFromAttendants()

			this.props.saveItem(currentNote, 'note', _ => { })
		}, debounceLength)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		const isStateEqual = isEqual(this.state, nextState)
		const isNotesEqual = isEqual(this.getProjectNotes(this.props), this.getProjectNotes(nextProps))
		const isKeyboardHeightEqual = this.props.keyboardHeight == nextProps.keyboardHeight

		if (isStateEqual && isNotesEqual && isKeyboardHeightEqual) {
			return false
		}

		return true
	}

	getProjectNotes = props => {
		const {
			currentProject,
			allNotes
		} = props

		const notes = []

		currentProject.notes.forEach(noteId => {
			const note = allNotes[noteId]

			if (note && !note.deleted_at) {
				notes.push(note)
			}
		})

		return notes
	}

	componentDidUpdate = (prevProps, prevState) => {
		const {
			currentProject
		} = this.props

		const {
			currentNote,
		} = this.state

		let shouldUpdateCurrentNote = false

		if (this.projectNotes.length) {
			if (!currentNote.id) {
				shouldUpdateCurrentNote = true
			}

			if (!this.projectNotes.find(note => {
				return note.id === currentNote.id
			})) {
				shouldUpdateCurrentNote = true
			}
		}

		if (shouldUpdateCurrentNote) {
			this.changeNote(this.projectNotes[0].id)
		}

		setTimeout(_ => {
			if (currentProject && currentProject.notes && prevProps.currentProject && prevProps.currentProject.notes) {
				if (currentProject.notes.length > prevProps.currentProject.notes.length) {
					this.focusEditor()
				}
			}
		}, 1)

		if (currentNote.id !== prevState.currentNote.id) {
			this.assessShowMeetingFieldsOnInit()
		}
	}

	assessShowMeetingFieldsOnInit = _ => {
		const {
			currentNote
		} = this.state

		const shouldShowMeetingFields = (currentNote.name || currentNote.location || (currentNote.attendants && currentNote.attendants.length))

		this.setState({
			showingMeetingFields: shouldShowMeetingFields
		})
	}

	componentDidMount = _ => {
		// removing this timeout breaks the tab transition, for some reason.
		setTimeout(_ => {
			this.setState({
				isEditorVisible: true
			}, _ => {
				this.focusEditor()
			})
		}, 100)

		const { currentProject } = this.props

		if(currentProject && currentProject.notes && !currentProject.notes.length){
			this.createNote()
		}
	}

	componentWillMount = _ => {
		doClickEventListeners(this.assessCloseDatePicker)
	}

	componentWillUnmount = _ => {
		doClickEventListeners(this.assessCloseDatePicker, true)
	}

	assessCloseDatePicker = e => {
		if (this.datePickerRef && !this.datePickerRef.contains(e.target)) {
			this.setState({
				datePickerOpen: false
			})
		}
	}

	focusEditor = _ => {
		if(this.quillRef && this.quillRef.quillRef){
			this.quillRef.quillRef.focus()
		}
	}

	changeNote = noteId => {
		const {
			allNotes
		} = this.props

		const note = allNotes[noteId]

		this.setState({
			currentNote: note,
		})
	}

	createNote = _ => {
		const {
			saveItem,
			currentProjectId
		} = this.props

		let newNote = {
			...this.emptyNoteTemplate
		}

		this.setState({
			currentNote: newNote
		})

		saveItem(newNote, 'note', _ => {
			const {
				allProjects
			} = this.props

			const projectObject = allProjects[currentProjectId]
			const lastNoteId = projectObject.notes[(projectObject.notes.length - 1)]

			this.changeNote(lastNoteId)
		})
	}

	deleteNote = (note = null) => {
		if (!note || !note.id) {
			note = this.state.currentNote
		}

		this.props.openModal('delete', 'note', { note })
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	canCreateNewNote = _ => {
		let canCreateNewNote = true

		const {
			currentNote
		} = this.state

		this.projectNotes.forEach(loopedNote => {
			const note = (currentNote && loopedNote.id == currentNote.id) ? currentNote : loopedNote

			let noteLines = paragraphToLines(note.text)
			let areLinesEmpty = true

			noteLines && noteLines.some(line => {
				if (line) {
					areLinesEmpty = false
					return true
				}
			})

			if (areLinesEmpty) {
				canCreateNewNote = false
			}
		})

		return canCreateNewNote
	}

	toggleCheckbox = type => {
		const {
			showingMeetingFields,
			currentNote
		} = this.state

		switch (type) {
			case 'show_meeting_fields':
				this.setState({
					showingMeetingFields: !showingMeetingFields
				})
				break
			case 'visible_to_guests':
				const newValue = currentNote.visible_to_guests ? false : true
				this.saveNote('visible_to_guests', newValue)
				break
		}

	}

	toggleDatePicker = _ => {
		this.setState({
			datePickerOpen: !this.state.datePickerOpen
		})
	}

	handleDateChange = date => {
		const formattedDate = moment(date).format('Y-MM-DD')

		if (this.state.currentNote.start_date === formattedDate) {
			this.saveNote('start_date', null)
		} else {
			this.saveNote('start_date', formattedDate)
		}

		this.setState({
			datePickerOpen: false
		})
	}

	getAllAttendants = _ => {
		const {
			allAttendants,
			currentAccount
		} = this.props

		const attendants = []

		currentAccount.attendants && currentAccount.attendants.forEach(attendantId => {
			const attendant = allAttendants[attendantId]

			if (attendant) {
				attendants.push(attendant)
			}
		})

		return attendants
	}

	getStringsFromAttendants = _ => {
		const {
			allAttendants
		} = this.props

		const {
			currentNote
		} = this.state

		const attendants = []

		if (currentNote) {
			currentNote.attendants && currentNote.attendants.forEach(attendantOrId => {
				if (typeof attendantOrId == 'number') {
					const attendant = allAttendants[attendantOrId]

					if(attendant){
						attendants.push(attendant.name)
					}
				} else {
					attendants.push(attendantOrId)
				}
			})
		}

		return attendants
	}

	changeAttendants = attendants => {
		this.saveNote('attendants', attendants)
	}

	exportNote = _ => {
		const {
			currentNote,
			isExportLoading
		} = this.state

		if (isExportLoading) {
			return
		}

		this.setState({
			isExportLoading: true
		}, _ => {
			setTimeout(_ => {
				this.setState({
					isExportLoading: false
				})
			}, 2000)
		})

		const anchor = document.createElement('a')
		anchor.href = API_URL + '/notes/export/' + currentNote.id

		document.body.appendChild(anchor)
		anchor.click()
		anchor.remove()
	}

	render() {

		const {
			currentNote,
			searchTerm,
			userMentions,
			isEditorVisible,
			showingMeetingFields,
			datePickerOpen,
			isExportLoading,
		} = this.state

		const {
			keyboardHeight,
			isArchivedProject,
			allProjects,
			allNotes,
			currentProjectId,
			userData,
			handleDismiss,
			validateResponse
		} = this.props

		const {
			roles,
			account
		} = this.context

		let spacerHeight = keyboardHeight ? (keyboardHeight - 60) : 0

		if (currentProjectId) {
			const projectObject = allProjects[currentProjectId]

			this.projectNotes = getAvailableNotes(projectObject, allNotes, roles)

			const canCreateNewNote = this.canCreateNewNote()

			const buttonProps = [
				{
					size: 'big',
					level: 'high',
					callback: this.createNote,
					label: 'Add new note',
					icon: 'fe-edit-2',
					disabled: (!canCreateNewNote || isArchivedProject),
					tooltip: (canCreateNewNote || isArchivedProject) ? null : 'You\'ve already got an empty note'
				},
				{
					size: 'big',
					level: 'low',
					callback: this.deleteNote,
					label: 'Delete note',
					icon: 'fe-trash-2',
					disabled: (this.projectNotes.length === 1 || isArchivedProject),
					tooltip: (isArchivedProject || this.projectNotes.length !== 1) ? null : 'Can\'t delete your last note'
				},
				{
					size: 'big',
					level: 'low',
					callback: this.exportNote,
					label: 'Export to PDF',
					icon: 'file-pdf-o',
					disabled: false,
					isLoading: isExportLoading,
				}
			]

			const checkboxProps = []

			if (account.isPremium) {
				checkboxProps.push({
					label: 'Show meeting fields',
					isChecked: showingMeetingFields,
					callback: _ => { this.toggleCheckbox('show_meeting_fields') }
				})
			}

			if (!roles.guest) {
				checkboxProps.push({
					label: 'Visible to guests',
					isChecked: (currentNote && currentNote.visible_to_guests),
					callback: _ => { this.toggleCheckbox('visible_to_guests') }
				})
			}

			const availableMentions = currentNote.visible_to_guests ? userMentions : userMentions.filter(user => {
				const userId = parseInt(user.url.replace('#mention-', ''))
				const isGuest = account.guestIds.indexOf(userId) !== -1

				return !isGuest
			})

			const wysiwygValue = (isArchivedProject && !currentNote.text) ? 'This is an empty note.' : currentNote.text

			return (
				<div className="project-notes">
					<MobileFooterButtons buttons={buttonProps} />
					{
						isMobile() ?
							<DropdownMenu
								isObjects={true}
								selectableItems={this.projectNotes}
								selectedItemId={currentNote.id}
								handleChange={this.changeNote}
								parentType="note"
							/>
							: null
					}
					<div className="page-column-main">
						<div>
							{ !isArchivedProject &&
							<SectionControls
								noSearch={true}
								buttons={buttonProps}
								checkboxProps={checkboxProps}
								toggleState={null}
								toggleChangeCallback={null}
								searchTerm={searchTerm}
								onSearchTermChange={this.onSearchTermChange}
								toggleOptions={null}
							/> }
							{isEditorVisible ?
								<SmoothCollapse
									allowOverflowWhenOpen={true}
									expanded={!!showingMeetingFields}
									heightTransition="0.15s ease"
								>
									<div className="notes-extra-fields">
										{ (!isArchivedProject || currentNote.name) ?
										<InputStandard
											outlineOnFocus={false}
											ref="meetingPurpose"
											callback={null}
											value={currentNote.name ? currentNote.name : ''}
											onChange={e => { this.handleTextChange(e.target.value, 'name') }}
											placeholder={`Meeting title`}
											disabled={isArchivedProject}
										/> : null }
										<div className="button-shelf">
											{ (!isArchivedProject || currentNote.start_date) ?
											<div ref={ref => this.datePickerRef = ref}>
												<DateContainer
													isEdit={true}
													isOpen={datePickerOpen}
													toggleCallback={this.toggleDatePicker}
													selectCallback={this.handleDateChange}
													initialMonth={new Date()}
													selectedDate={currentNote.start_date}
													label="Meeting date"
													disabled={isArchivedProject}
												/>
											</div>
											: null }
											{ (!isArchivedProject || currentNote.location) ?
											<InputStandard
												value={currentNote.location ? currentNote.location : ''}
												onChange={e => { this.handleTextChange(e.target.value, 'location') }}
												placeholder={`Where is it?`}
												disabled={isArchivedProject}
											/> : null }
											{ (!isArchivedProject || this.getStringsFromAttendants().length) ?
											<TagsInput
												existingTags={this.getAllAttendants()}
												onChange={this.changeAttendants}
												value={this.getStringsFromAttendants()}
												placeholder={`Who's attending?`}
												parentType={'attendant'}
												valueKey={'name'}
												disabled={isArchivedProject}
											/> : null }
										</div>
									</div>
								</SmoothCollapse>
								: null}
							<QuillWysiwyg
								isVisible={isEditorVisible}
								value={wysiwygValue}
								onChange={this.handleChange}
								ref={ref => this.quillRef = ref}
								canCollaborate={true}
								thisUser={userData}
								objectId={currentNote.id}
								availableMentions={availableMentions}
								canEdit={!isArchivedProject}
								placeholder="Write general notes here, e.g contact details, meeting minutes or feedback."
							/>
						</div>
					</div>
					{
						!isMobile() &&
						<div className="page-column-aside">
							<ul>
								<FlipMove
									duration={250}
									easing="ease-out"
									enterAnimation="accordionVertical"
									leaveAnimation="accordionVertical"
								>
									{this.projectNotes.map((note, i) => {
										let thisNote = note
										let isCurrent = false

										if (currentNote.id == note.id) {
											thisNote = this.state.currentNote
											isCurrent = true
										}

										return (
											<Note
												key={note.id}
												note={thisNote}
												isCurrent={isCurrent}
												changeNote={this.changeNote}
												deleteNote={this.deleteNote}
												canDelete={!!(this.projectNotes.length > 1 && !isArchivedProject)}
											/>
										)
									})}
								</FlipMove>
							</ul>
							<div className="validation-response">
								<ValidateResponse dismissCallback={handleDismiss} response={validateResponse} />
							</div>
						</div>
					}
					<div className="keyboard-height-spacer" style={{ height: spacerHeight + 'px' }} />
				</div>
			);
		} else {
			return null
		}
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		currentProjectId: state.account.currentProjectId,
		allProjects: state.account.entities.projects,
		allNotes: state.account.entities.notes,
		allUsers: state.account.entities.users,
		allAttendants: state.account.entities.attendants ? state.account.entities.attendants : {},
		currentAccount: state.account.currentAccount ? state.account.entities.accounts[state.account.currentAccount.id] : null,
		keyboardHeight: state.account.keyboardHeight
	}
}

const ProjectNotesWithValidateResponse = withValidateResponse(ProjectNotes);

export default withRouter(connect(mapStateToProps, { 
	saveItem, 
	openModal 
})(ProjectNotesWithValidateResponse))

ProjectNotes.contextType = MainContext


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-notes/project-notes.jsx